import SiteLayout from "@/components/feature/SiteLayout";
import { usePageMeta } from "@/hooks/usePageMeta";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryQuickLinks from "@/pages/home/components/CategoryQuickLinks";
import LatestPicks from "@/pages/home/components/LatestPicks";
import NewsAndRanking from "@/pages/home/components/NewsAndRanking";
import ActorsStrip from "@/pages/home/components/ActorsStrip";
import MyLibrary from "@/pages/home/components/MyLibrary";
import EditorialBlock from "@/pages/home/components/EditorialBlock";

export default function Home() {
  usePageMeta({
    title: "华丽的外出影视大全 - 剧情介绍与最新动态",
    description:
      "华丽的外出官网，提供影视作品剧情介绍、演员信息、剧集详情及相关新闻动态，满足用户对影视内容的全面了解需求。",
    keywords: "华丽的外出,影视,剧情介绍,演员名单,剧集信息,影视动态,华丽的外出剧情",
  });

  return (
    <SiteLayout>
      <HeroCarousel />
      <CategoryQuickLinks />
      <LatestPicks />
      <ActorsStrip />
      <NewsAndRanking />
      <MyLibrary />
      <EditorialBlock />
    </SiteLayout>
  );
}